import type { CertGenExpandedParams } from 'common.components/certificates-expanded-params-modal/typings';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { intoHtml } from '../../../utils/html';

interface Props extends CertGenExpandedParams {
    slug?:
        | 'KPKInformatics7Autumn2022'
        | 'KPKInformatics8Autumn2022'
        | 'KPKInformatics9Autumn2022'
        | 'KPKInformaticsPythonAutumn2022'
        | 'KPKInfromaticsNeuroWinter2024'
        | 'KPKNeuroAutumn2025'
        | 'KPKProforientation2025';
}

/** Шаблон для серта за КПК */
// eslint-disable-next-line complexity
export const TeacherTrainingCoursesCert = ({
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    has_higher_education: hasHigherEducation,
    serial_number: serialNumber,
    issue_date: issueDate,
    gender,
    slug,
}: Props) => {
    const certName = hasHigherEducation === 'Да' ? 'Удостоверение' : 'Сертификат';
    const genderWordEnding = gender === 'Ж' ? 'ла' : 'ел';

    let courseName: string = '';
    let hours: number = 0;

    let firstPageBackgroundImg: string = '';
    let secondPageBackgroundImg: string = '';

    let formattedIssueDate = '';

    if (issueDate) {
        const isoIssueDate = new Date(issueDate);

        formattedIssueDate = format(isoIssueDate, 'd MMMM yyyy', { locale: ru });
    }

    switch (slug) {
        case 'KPKInformatics7Autumn2022':
            firstPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/2A0J-Ut6bC6Xa1RYex7h7/orig';
            secondPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/_6EiPtqo5OCpcqyPKwGpP/orig';
            courseName = 'Организация уроков информатики в 7-м классе';
            hours = 36;

            break;
        case 'KPKInformatics8Autumn2022':
            firstPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/6887102/f8wcA4M_H8YzjCpQS1ck_/orig';
            secondPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/PMpQOxq8-V3qw5nK8yIMM/orig';
            courseName = 'Организация уроков информатики в 8-м классе';
            hours = 36;

            break;
        case 'KPKInformatics9Autumn2022':
            firstPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/1IbBpNLIK94XWbECzyRP5/orig';
            secondPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/W1HWQ3Vu5sQxGUEnfSSuV/orig';
            courseName = 'Организация уроков информатики в 9-м классе';
            hours = 36;

            break;
        case 'KPKInformaticsPythonAutumn2022':
            firstPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/6887102/BrAw9L6wGakrzy4LJ3afV/orig';
            secondPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/bdMloOs-yH2vMzpbcsi9K/orig';
            courseName = 'Углубленное программирование на Python для учителей';
            hours = 36;
            break;
        case 'KPKInfromaticsNeuroWinter2024':
        case 'KPKNeuroAutumn2025':
            firstPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/SzWoFd4Q7pg97aABmK5qZ/orig';
            secondPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/wLrhKPEHRqq9dMzcTezq3/orig';

            // EDUCATION-44106
            const isCourseNameChanged =
                slug === 'KPKNeuroAutumn2025' ||
                (issueDate && new Date(issueDate).getTime() >= new Date('2024-03-16').getTime());

            courseName = isCourseNameChanged
                ? 'Использование инструментов искусственного интеллекта в педагогической практике'
                : 'Нейросети для учителей';
            hours = 16;

            break;
        case 'KPKProforientation2025':
            firstPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/O9pA4mkOMAds4zflXH_d2/orig';
            secondPageBackgroundImg =
                'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/P9JzsGExgsNIjgePfAxzm/orig';
            courseName = 'Педагогическое мастерство';
            hours = 32;

            break;
    }

    const getWpx = (px: number) => `calc(297 / 860 * ${px}mm)`;
    const getHpx = (px: number) => `calc(210 / 614 * ${px}mm)`;

    return intoHtml`<!DOCTYPE html>
        <html lang="ru">
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
                <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
                <style>
                    @font-face {
                        font-family: 'YS Text';
                        src: url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff') format('woff');
                        font-weight: 300;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: 'YS Text';
                        src: url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff') format('woff');
                        font-weight: 400;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: 'YS Text';
                        src: url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff') format('woff');
                        font-weight: 500;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: 'YS Text';
                        src: url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff') format('woff');
                        font-weight: bold;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: 'YS Display';
                        font-weight: bold;
                        font-style: normal;
                        font-stretch: normal;

                        src: url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff2') format('woff2'),
                        url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff') format('woff');
                    }

                    @font-face {
                        font-family: 'YS Display';
                        font-weight: 800;
                        font-style: normal;
                        font-stretch: normal;

                        src: url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff2') format('woff2'),
                        url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff') format('woff');
                    }

                    @page {
                        size: 297mm 210mm;
                        margin: 0;
                        padding: 0;
                    }

                    @media print {
                        html,
                        body {
                            box-sizing: border-box;
                            width: 297mm;
                            height: 210mm;

                            color-adjust: exact;
                            print-color-adjust: exact;
                            -webkit-print-color-adjust: exact;
                        }
                    }

                    html {
                        position: relative;

                        margin: 0;
                        padding: 0;
                    }

                    body {
                        margin: 0;

                        font-family: 'YS Text';
                        color: rgba(0, 0, 0, 0.9);
                    }

                    .page {
                        position: relative;

                        overflow: hidden;

                        box-sizing: border-box;

                        width: 297mm;
                        height: 209.5mm;

                        background: #fff;

                        page-break-after: always;
                    }

                    .page-1
                    {
                        background-image: url('${firstPageBackgroundImg}'); 
                        background-size: cover; 
                        background-position: center;
                        background-repeat: no-repeat;
                    }

                    .page-2
                    {
                        background-image: url('${secondPageBackgroundImg}'); 
                        background-size: cover; 
                        background-position: center;
                        background-repeat: no-repeat;
                    }

                    .title {
                        position: absolute;
                        left: ${getWpx(425)};
                        top: ${getHpx(40)};

                        font-size: 48pt;
                        line-height: 56pt;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.9);
                    }

                    .course {
                        position: absolute;
                        left: ${getWpx(425)};
                        top: ${getHpx(483)};

                        max-width: ${getWpx(335)};

                        font-size: 20pt;
                        line-height: 24pt;
                        color: rgba(0, 0, 0, 0.6);
                    }

                    .serialNumber {
                        position: absolute;
                        left: ${getWpx(36)};
                        bottom: ${getHpx(36)};

                        font-size: 10pt;
                        line-height: 14pt;
                        color: rgba(0, 0, 0, 0.6);
                    }

                    .assignment {
                        position: absolute;
                        left: ${getWpx(305)};
                        top: ${getHpx(44)};

                        font-size: 16pt;
                        line-height: 24pt;
                    }

                    .footer {
                        position: absolute;
                        right: ${getWpx(44)};
                        bottom: ${getHpx(44)};

                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;

                        font-size: 11pt;
                        line-height: 16pt;
                    }

                    .plate {
                        margin-top: ${getHpx(3)};
                        
                        width: fit-content;
                        padding: ${getHpx(6)} ${getWpx(10)};
                        background-color: rgba(0, 0, 0, 0.05);
                        border-radius: 10px;
                    }
                </style>
            </head>
            <body>
                <div class="page page-1">
                    <div class="serialNumber">
                        Регистрационный номер<br>
                        ${serialNumber || ''}
                    </div>

                    <div class="title">
                        ${certName}<br>
                        о повышении <br>
                        квалификации
                    </div>

                    <div class="course">
                        Курс «${courseName}»
                    </div>
                </div>

                <div class="page page-2">
                    <div class="assignment">
                        <strong>${lastName} ${firstName} ${middleName}</strong> успешно прош${genderWordEnding} обучение в Яндекс Учебнике по программе <br/> «${courseName}». <br/> Объем курса ${hours} часов.
                    </div>

                    <div class="footer">
                        <div class="plate">
                            ${formattedIssueDate}
                        </div>
                        <div class="plate">
                            г. Москва
                        </div>
                    </div>
                </div>
            </body>
        </html>`;
};
